module.exports = "import React from \"react\";\nimport { Showcase } from \"../../lib\";\n\nconst demo = (<div>I'm in a showcase!</div>);\nconst source = \"(<div>I'm in a showcase!</div>)\";\n\nexport default () => (\n  <Showcase\n    demo={demo}\n    source={source} />);\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/Showcase/demo/SimpleUsage.js
// module id = 135
// module chunks = 0